import { Link } from "react-router";
import { EmptyState } from "../components/ui.tsx";
import { useT } from "../i18n/index.tsx";

export function NotFound() {
  const t = useT();
  return (
    <div className="page">
      <EmptyState title={t.auth.notFoundTitle} art action={<Link to="/" className="btn btn-primary">{t.auth.goToOverview}</Link>}>
        {t.auth.notFoundBody}
      </EmptyState>
    </div>
  );
}
